import React from 'react';
import PropTypes from 'prop-types';

export default function ProviderButton({onProviderClick, provider}) {
    return (
        <button
            className="unbutton provider-button"
            type="button"
            onClick={() => onProviderClick(provider)}
        >
            <img className="provider-icon" alt="" src={provider.iconUrl} />
            {provider.displayName}
        </button>
    );
}

ProviderButton.propTypes = {
    onProviderClick: PropTypes.func.isRequired,
    provider: PropTypes.shape({
        iconUrl: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired
    }).isRequired
};
